export default "__VITE_ASSET__BUWNl_85__"